import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface RegistrarPonto {
  idTipoRegistro: number;
}

export interface SaldoDiario {
  idUsuario: number;
  idJornadaTrabalho: number;
  data: string;
  saldoMinutos: number;
  saldoFormatado: string;
}

export interface RegistroRecente {
  data: string;
  entrada: string | null;
  saidaAlmoco: string | null;
  voltaAlmoco: string | null;
  saida: string | null;
  horasTrabalhadas: string;
}
export interface ResumoPontoDto {
  horasHoje: string;
  horasSemana: string;
  horasMes: string;
  bancoHoras: string;
}


@Injectable({
  providedIn: 'root'
})
export class RegistroPontoService {

  private apiUrl = 'https://localhost:7103/api/RegistroPonto';

  constructor(private http: HttpClient) {}

  registrarPonto(dto: RegistrarPonto): Observable<SaldoDiario> {
    return this.http.post<SaldoDiario>(
      `${this.apiUrl}/RegistrarHorario`,
      dto
    );
  }

 getUltimoRegistro() {
  return this.http.get<number | null>(`${this.apiUrl}/ObterTipoRegistro`);
}

getResumo() {
  return this.http.get<ResumoPontoDto>(
    `${this.apiUrl}/resumo`);
}

getRegistrosRecentes(dias: number) {
  return this.http.get<RegistroRecente[]>(
    `${this.apiUrl}/recentes?dias=${dias}`);
}


}
